export class TipoAsignacion {
  idTipoAsignacion: number;
  tipoBase: string;
  nombreTipoAsignacion: string;
  descripcion: string;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/tipo-asignacion.ts